import { gql, useMutation } from '@apollo/client';
import { useLogger } from '@amzn/xb-hooks';

export const CREATE_USER_REQUEST = gql`
    mutation createUserRequest($organizationId: ID!, $resourceId: ID!) {
        createUserRequest(
            input: { organizationId: $organizationId, userRequestResourceType: ILT_LEARNING_ACTIVITY, resourceId: $resourceId }
        ) {
            id
            resourceIds
            userRequestResourceType
            userRequestStatus
        }
    }
`;

export const useCreateUserRequest = () => {
    const { log } = useLogger();
    return useMutation(CREATE_USER_REQUEST, {
        onError: (error) => {
            log.error('Error creating user request', error);
        },
    });
};
